// Server-injected hint about CMS top bars (announcement bar + top banners).
// `window.__UO_TOP_BARS__` is embedded in the HTML by the server (see
// server/ssr-helpers.ts) on every page load, so the client knows — before any
// API request resolves, including on a first-ever visit — whether these bars
// will render, and can reserve their space deterministically (CLS fix).

export interface TopBannerHint {
  id: string;
  targetPages: string[] | null;
  dismissible: boolean;
}

export interface TopBarsHint {
  announcementBar: boolean;
  topBanners: TopBannerHint[];
}

declare global {
  interface Window {
    __UO_TOP_BARS__?: TopBarsHint;
  }
}

export function getTopBarsHint(): TopBarsHint | null {
  if (typeof window === "undefined") return null;
  const hint = window.__UO_TOP_BARS__;
  if (!hint || typeof hint.announcementBar !== "boolean" || !Array.isArray(hint.topBanners)) {
    return null;
  }
  return hint;
}

// Returns the top banners the server expects to be visible on the given
// location, excluding those the visitor has already dismissed.
export function getExpectedTopBanners(location: string, dismissedIds: string[]): TopBannerHint[] {
  const hint = getTopBarsHint();
  if (!hint) return [];
  const currentPath = location === "/" ? "home" : location.slice(1);
  return hint.topBanners.filter((b) => {
    if (b.dismissible && dismissedIds.includes(b.id)) return false;
    if (b.targetPages && b.targetPages.length > 0) {
      if (!b.targetPages.includes(currentPath) && !b.targetPages.includes("*")) return false;
    }
    return true;
  });
}
